import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Auth/Login";
import CompanyRegister from "@/views/Auth/registerCompany";
import FactoryRegister from "@/views/Auth/registerFactory";
import RegisterUser from "@/views/Auth/index";
import tickets from "@/views/SharedPages/Tickets/index";
import Home from "@/views/Home/index";
import Manitoring from "@/views/Home/manitoring.vue";
import Companies from "@/views/Companies/Index";
import CompanyUsers from "@/views/Companies/Users/index";
import profileFactory from "@/views/FactoryDir/Profile/index.vue";
import profileCompany from "@/views/CompanyDir/Profile/index.vue";



Vue.use(VueRouter);
let routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "داشبورد",
      // layout: 'AppLayoutUser',
      guest: true,
    },
  },
  {
    path: "/manitoring",
    name: "manitoring",
    component: Manitoring,
    meta: {
      title: "پایش",
      // layout: 'AppLayoutUser',
      guest: true,
    },
  },
  {
    path: "/auth/login",
    name: "login",
    component: Login,
    meta: {
      title: "ورود به پنل",
      layout: "AppLayoutAuth",
      guest: true,
    },
  },
  {
    path: "/auth/register",
    name: "register",
    component: RegisterUser,
    meta: {
      title: "ثبت نام",
      layout: "AppLayoutAuth",
    },
  },
  {
    path: "/auth/registerFactory",
    name: "registerFactory",
    component: FactoryRegister,
    meta: {
      title: "ثبت نام واحد صنفی",
      layout: "AppLayoutRegisterFactory",
      guest: true,
    },
  },
  {
    path: "/auth/registerCompany",
    name: "registerCompany",
    component: CompanyRegister,
    meta: {
      title: "ثبت نام شرکت",
      layout: "AppLayoutRegisterCompany",
      guest: true,
    },
  },
  {
    path: "*",
    name: "noPage",
    redirect: "/",
  },
];
if (localStorage.getItem("role") === "ADMIN" && localStorage.getItem("token")) {
  routes.push(
    {
      path: "/hall-announcement/list",
      component: () => import("../views//hall-announcement/index.vue"),
      meta: "سالن اعلام بار سریع",
    },
    {
      path: "/discountCode/list",
      component: () => import("../views/DiscountCode/Index.vue"),
      meta: "لسیت کد تخفیف",
    },
    {
      path: "/checkList/list",
      component: () => import("../views/checkList/Index.vue"),
      meta: "چک لیست",
    },
    {
      path: "/hall-announcement/list/:type",
      component: () => import("../views//hall-announcement/index.vue"),
      meta: "سوابق اعلام بار سریع",
    },
    {
      path: "/carsList",
      name: "cars",
      component: () => import("../views/Drivers/carsList"),
      meta: "لیست ناوگان",
    },
    {
      path: "/parsfoolad/orders",
      name: "parsfooladOrders",
      component: () => import("../views/Orders/Parsfoolad/index"),
      meta: "اعلام بارهای فولاد",
    },
    {
      path: "/notification-times/:driverId",
      name: "notification-times",
      component: () => import("../views/Drivers/NotificationTimes"),
      meta: "اطلاع رسانی  بارها",
    },
    {
      path: "/factories",
      name: "factories",
      component: () => import("../views/Factories/index"),
      meta: "لیست واحد های صنفی",
    },
    {
      path: "/updateCategory",
      name: "updateCategory",
      component: () => import("../views/Settings/productCategory"),
      meta: "دسته بندی محصولات",
    },
    {
      path: "/turnOver-sum",
      name: "turnOver-sum",
      component: () => import("../views/Payments/turnOverSumList.vue"),
      meta: "گردش مالی سیستم",
    },
    {
      path: "/extendTurnsHistory",
      name: "turn-extension-history",
      component: () => import("../views/Drivers/Turns/extendTurnsHistory.vue"),
      meta: "سوابق حذف یا تمدید نوبت ها",
    },
    {
      path: "/drivers-offline",
      name: "drivers-offline",
      component: () => import("../views/Drivers/driverOffline.vue"),
      meta: "راننده های افلاین",
    },
    {
      path: "/bankAccountList",
      component: () => import("../views/Payments/bankAccountList.vue"),
      meta: {
        title: "حساب ها",
      },
    },
    {
      path: "/banDriver",
      component: () => import("../views/SharedPages/banDriverList.vue"),
      meta: {
        title: "راننده های مسدود",
      },
    },
    {
      path: "/withdrawList",
      component: () => import("../views/Payments/withdrawList.vue"),
      meta: {
        title: "برداشت ها",
      },
    },
    {
      path: "/withdrawListPending",
      component: () => import("../views/Payments/withdrawListPending.vue"),
      meta: {
        title: "برداشت ها در انتطار",
      },
    },
    {
      path: "/bankAccountListPending",
      component: () => import("../views/Payments/bankAccountPending.vue"),
      meta: {
        title: "حساب های در انتظار",
      },
    },
    {
      path: "/realPersonFactories",
      name: "realPersonFactories",
      component: () => import("../views/Factories/realPersonFactories"),
      meta: "لیست اشخاص حقیقی",
    },
    {
      path: "/print/Remittance/:id",
      name: "printRemittance",
      component: () => import("../views/Print/Remittance"),
      meta: {
        title: "پرینت مجوز بارنامه",
        layout: "AppLayoutPrint",
      },
    },
    {
      path: "/distances",
      name: "distances",
      component: () => import("../views/Distance/Index"),
      meta: "فاصله شهر ها",
    },
    {
      path: "/inquiry/lastWayBill/:type/:text",
      name: "inquiry/wayBill",
      component: () => import("../views/inquiry/waybill/index.vue"),
      meta: "استعلام بارنامه",
    },
    {
      path: "/inquiry/lastWayBill/:type",
      name: "inquiry/wayBill",
      component: () => import("../views/inquiry/waybill/index.vue"),
      meta: "استعلام بارنامه",
    },
    {
      path: "/inquiry/lastWayBill",
      name: "inquiry/wayBill",
      component: () => import("../views/inquiry/waybill/index.vue"),
      meta: "استعلام بارنامه",
    },
    {
      path: "/drivers/cars/:id",
      name: "carDriver",
      component: () => import("../views/Drivers/Cars/Index"),
      meta: "ناوگان راننده",
    },
    {
      path: "/access/admins",
      name: "admins",
      component: () => import("../views/Access/admins"),
      meta: "لیست مدیران سیستم",
    },
    {
      path: "/cards",
      name: "cards",
      component: () => import("../views/Card/index"),
      meta: "لیست شماره کارت واریزی",
    },
    {
      path: "/withdraw",
      name: "withdraw",
      component: () => import("../views/Withdraw/index"),
      meta: "لیست درخواست های برداشت",
    },
    {
      path: "/exit",
      name: "exit",
      component: () => import("../views/Exit/Exit"),
      meta: "خروج",
    },
    {
      path: "/access/roles",
      name: "roles",
      component: () => import("../views/Access/roles"),
      meta: "لیست سطوح دسترسی",
    },
    {
      path: "/remittanceDischarge",
      name: "remittanceDischarge",
      component: () => import("../views/RemittanceDischarge/index"),
      meta: "لیست حواله های تخیلیه",
    },
    {
      path: "/smartCardRenewal",
      name: "smartCardRenewal",
      component: () => import("../views/SmartCardRenewal/index.vue"),
      meta: "تمدید کارت هوشمند",
    },
    {
      path: "/smartCardRenewal/:id",
      name: "smartCardRenewal",
      component: () => import("../views/SmartCardRenewal/index.vue"),
      meta: "تمدید کارت هوشمند",
    },
    {
      path: "/terminals",
      name: "terminals",
      component: () => import("../views/Terminals/Index"),
      meta: "لیست پایانه ها",
    },
    {
      path: "/terminals/newTerminal",
      name: "newTerminal",
      component: () => import("../views/Terminals/new"),
      meta: "ایجاد پایانه جدید",
    },
    {
      path: "/terminals/editTerminal/:id",
      name: "editTerminal",
      component: () => import("../views/Terminals/new"),
      meta: "ویرایش پایانه بار",
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("../views/Settings/index"),
      meta: "تنظیمات سامانه",
    },
    {
      path: "/factories/detail/:id",
      name: "detailFactory",
      component: () => import("../views/Factories/detail"),
      meta: "ویرایش اطلاعات واحد صنفی",
    },
    {
      path: "/factories-:id/users",
      name: "factories-users",
      component: () => import("../views/Factories/Users/index.vue"),
      meta: "لیست کاربران واحد صنفی",
    },
    {
      path: "/factories-:factoryId/user-:userId/edit",
      name: "factories-users-edit",
      component: () => import("../views/Factories/Users/edit.vue"),
      meta: "ویرایش کاربر واحد صنفی",
    },
    {
      path: "/factories/companiesList/:id",
      name: "companiesList",
      component: () => import("../views/Factories/companiesList"),
      meta: "لیست شرکت های واحد صنفی",
    },
    {
      path: "/factories/turnOver/:id",
      name: "factoriesTurnOver",
      component: () => import("../views/Factories/TurnOver/index"),
      meta: "گردش مالی واحد صنفی",
    },
    {
      path: "/factories/new",
      name: "createFactory",
      component: () => import("../views/Factories/new"),
      meta: "ایجاد  واحد های صنفی",
    },
    {
      path: "/companies",
      name: "companies",
      component: Companies,
      meta: "لیست شرکت ها",
    },
    {
      path: "/payments",
      name: "payments",
      component: () => import("../views/Payments/payment"),
      meta: "لیست درخواست های واریز",
    },
    {
      path: "/receipts",
      name: "receipts",
      component: () => import("../views/Receipts/index"),
      meta: "لیست فیش های واریزی",
    },
    {
      path: "/companies/receipts/:companyId",
      name: "companiesReceipts",
      component: () => import("../views/Companies/Receipts/Index"),
      meta: "لیست فیش های واریزی",
    },
    {
      path: "/companies/turnOver/:companyId",
      name: "companiesTurnOver",
      component: () => import("../views/Companies/TurnOver/index"),
      meta: "گردش مالی شرکت",
    },
    {
      path: "/receiptHistory",
      name: "receiptHistory",
      component: () => import("../views/Receipts/ReceiptHistory"),
      meta: "لیست سوابق فیش های واریزی",
    },
    {
      path: "/companies/users/:companyId",
      name: "userCompany",
      component: CompanyUsers,
      meta: "لیست کاربران شرکت",
    },
    {
      path: "/companies/detail/:companyId",
      name: "companyDetail",
      component: () => import("../views/Companies/detail"),
      meta: "پنل ادمین پاژ",
    },
    {
      path: "/companies/new",
      name: "createCompany",
      component: () => import("../views/Companies/new"),
      meta: "ایجاد شرکت جدید",
    },
    {
      path: "/drivers",
      name: "drivers",
      component: () => import("../views/Drivers/Index"),
      meta: "لیست راننده ها",
    },
    {
      path: "/drivers/turns-detail",
      name: "turnsDetail",
      component: () => import("../views/Drivers/Turns/TurnsDetail.vue"),
      meta: "جزئیات نوبت ها",
    },
    {
      path: "/drivers/turnOver/:driverId",
      name: "driverTurnOver",
      component: () => import("../views/Drivers/TurnOver/index"),
      meta: "گردش حساب راننده",
    },
    {
      path: "/tracking",
      name: "tracking",
      component: () => import("../views/Tracking/index"),
      meta: "ردیابی حواله ها",
    },
    {
      path: "/drivers/reservations/:driverId",
      name: "reservation",
      component: () => import("../views/Drivers/Reservations/index"),
      meta: "لیست رزورهای جاری راننده",
    },
    {
      path: "/drivers/reservationHistory/:driverId",
      name: "reservationHistory",
      component: () => import("../views/Drivers/ReservationHistory/index"),
      meta: "لیست سوابق رزورهای راننده",
    },
    {
      path: "/drivers/turns/:nationalId",
      name: "turn",
      component: () => import("../views/Drivers/Turns/index"),
      meta: "لیست نوبت ها",
    },
    {
      path: "/drivers/turns",
      name: "turns",
      component: () => import("../views/Drivers/Turns/Turns"),
      meta: "لیست نوبت های رانندگان",
    },
    {
      path: "/drivers/detail/:driverId",
      name: "detailDriver",
      component: () => import("../views/Drivers/Detail/index"),
      meta: "جزییات راننده",
    },
    {
      path: "/drivers/remittanceHistory/:driverId",
      name: "remittanceHistoryDriver",
      component: () => import("../views/Drivers/RemittanceHistory/index"),
      meta: "سوابق حواله راننده",
    },
    {
      path: "/drivers/remittance/:driverId",
      name: "remittanceDriver",
      component: () => import("../views/Drivers/Remittance/index"),
      meta: "حواله جاری راننده",
    },
    {
      path: "/orders",
      name: "orders",
      component: () => import("../views/Orders/index"),
      meta: "اعلام بار های جاری",
    },
    {
      path: "/orderHistory",
      name: "orderHistory",
      component: () => import("../views/OrderHistory/orderHistory"),
      meta: "سوابق اعلام بار",
    },
    {
      path: "/orders/detail/:orderId",
      name: "detailOrder",
      component: () => import("../views/Orders/Detail/index"),
      meta: "جزییات اعلام بار",
    },
    {
      path: "/support",
      name: "support",
      component: () => import("../views/Supports/index"),
      meta: "لیست پیام های پشتیبانی",
    },
    {
      path: "/support-history",
      name: "supportHistory",
      component: () => import("../views/Supports/TicketsHistory.vue"),
      meta: "سوابق تیکت ها",
    },
    {
      path: "/support/ticket/:ticketId",
      name: "ticket",
      component: () => import("../views/Supports/Ticket"),
      meta: "جزییات پیام پشتیبانی",
    },
    {
      path: "/carbreakdown",
      name: "carBreakDown",
      component: () => import("../views/Supports/CarBreakDown"),
      meta: "لیست اعلام خرابی ها",
    },
    {
      path: "/remittance",
      name: "remittance",
      component: () => import("../views/Remittance/index"),
      meta: "لیست حواله های جاری",
    },
    {
      path: "/tracking/:id",
      name: "remittanceTracking",
      component: () => import("../views/Remittance/tracking"),
      meta: "مسیر طی شده",
    },
    {
      path: "/remittanceHistory",
      name: "remittanceHistory",
      component: () => import("../views/RemittanceHistory/remittanceHistory"),
      meta: "لیست سوابق حواله ها",
    }
  );
}
if (
  (localStorage.getItem("role") === "COMPANY" &&
    localStorage.getItem("token")) ||
  (localStorage.getItem("role") === "COMPANY_MEMBER" &&
    localStorage.getItem("token"))
) {
  routes.push(
    {
      path: "/hall-announcement/list",
      name: "createUser",
      component: () =>
        import("../views/CompanyDir//hall-announcement/index.vue"),
      meta: "سالن اعلام بار سریع",
    },
    {
      path: "/checkList/list",
      component: () => import("../views/CompanyDir/checkList/Index.vue"),
      meta: "چک لیست",
    },
    {
      path: "/hall-announcement/list/:type",
      name: "createUser",
      component: () =>
        import("../views/CompanyDir//hall-announcement/index.vue"),
      meta: "سوابق  اعلام بار سریع",
    },
    {
      path: "/turnOver",
      name: "turnOver",
      component: () => import("../views/CompanyDir/TurnOver/index"),
      meta: "گردش مالی",
    },
    {
      path: "/bankAccountList",
      component: () => import("../views/SharedPages/bankAccountList.vue"),
      meta: {
        title: "حساب ها",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/address",
      component: () => import("../views/SharedPages/address.vue"),
      meta: {
        title: "آدرس ها",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/banDriver",
      component: () => import("../views/SharedPages/banDriverList.vue"),
      meta: {
        title: "راننده های مسدود",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/paymentRent",
      name: "paymentRent",
      component: () => import("../views/SharedPages/paymentRent.vue"),
      meta: {
        title: "پرداخت کرایه",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/withdrawList",
      component: () => import("../views/SharedPages/withdrawList.vue"),
      meta: {
        title: "برداشت",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/tracking",
      name: "tracking",
      component: () => import("../views/CompanyDir/Tracking/index"),
      meta: "ردیابی حواله ها",
    },
    {
      path: "/tracking/:id",
      name: "RemittanceTrackingCompany",
      component: () => import("../views/CompanyDir/Remittance/tracking"),
      meta: "ردیابی حواله ها",
    },
    {
      path: "/c/profile",
      component: profileCompany,
      children: [
        {
          path: "",
          name: "profileCompany",
          component: () => import("@/views/CompanyDir/Profile/info.vue"),
          meta: {
            title: "پروفایل",
          },
        },
        {
          path: "edit",
          name: "editProfileCompany",
          component: () => import("@/views/CompanyDir/Profile/edit.vue"),
          meta: {
            title: "ویرایش پروفایل",
          },
        },
        {
          path: "auth-docs",
          name: "authDocs",
          component: () => import("@/views/CompanyDir/Profile/authDocs.vue"),
          meta: {
            title: "مدارک",
          },
        },
      ],
      meta: {
        title: "profile",
        layout: "AppLayoutUser",
        // guest: true
      },
    },
    {
      path: "/tickets",
      name: "tickets",
      component: tickets,
      meta: {
        title: "tickets",
        layout: "AppLayoutUser",
        guest: true,
      },
    },
    {
      path: "/exit",
      name: "exit",
      component: () => import("../views/Exit/Exit"),
      meta: "خروج",
    },
    {
      path: "/payments",
      name: "payments",
      component: () => import("../views/CompanyDir/Receipts/payment"),
      meta: "لیست شارژ حساب",
    },
    {
      path: "/waybills/new",
      name: "waybillsNew",
      component: () => import("../views/CompanyDir/Waybills/new"),
      meta: "ایجاد درخواست",
    },
    {
      path: "/waybills",
      name: "waybills",
      component: () => import("../views/CompanyDir/Waybills/index"),
      meta: "لیست درخواست های حواله",
    },
    {
      path: "/waybillHistory",
      name: "waybillHistory",
      component: () => import("../views/CompanyDir/Waybills/history"),
      meta: "لیست سوابق درخواست های حواله",
    },
    {
      path: "/receipts",
      name: "receipts",
      component: () => import("../views/CompanyDir/Receipts/index"),
      meta: "سوابق ثبت فیش",
    },
    {
      path: "/storeReceipt",
      name: "storeReceipt",
      component: () => import("../views/CompanyDir/Receipts/store"),
      meta: "ثبت فیش جدید",
    },
    {
      path: "/users",
      name: "users",
      component: () => import("../views/CompanyDir/Users/index"),
      meta: "لیست کاربران شرکت",
    },
    {
      path: "/users/new",
      name: "createUser",
      component: () => import("../views/CompanyDir/Users/new"),
      meta: "ایجاد کاربر جدید",
    },
    {
      path: "/orders",
      name: "orders",
      component: () => import("../views/CompanyDir/Orders/index"),
      meta: "اعلام بار های جاری",
    },
    {
      path: "/allOrders",
      name: "allOrders",
      component: () => import("../views/CompanyDir/Orders/allOrderSystem"),
      meta: "سالن اعلام بار",
    },
    {
      path: "/orders/new",
      name: "storeOrder",
      component: () => import("../views/CompanyDir/Orders/new"),
      meta: "اعلام بار جدید",
    },
    {
      path: "/orders/detail/:orderId",
      name: "detailOrder",
      component: () => import("../views/CompanyDir/Orders/Detail/index"),
      meta: "جزییات اعلام بار",
    },
    {
      path: "/orderHistory",
      name: "orderHistory",
      component: () => import("../views/CompanyDir/OrderHistory/orderHistory"),
      meta: "لیست سوابق اعلام بار",
    },
    {
      path: "/remittance",
      name: "remittance",
      component: () => import("../views/CompanyDir/Remittance/index"),
      meta: "لیست حواله های جاری",
    },
    {
      path: "/remittanceHistory",
      name: "remittanceHistory",
      component: () =>
        import("../views/CompanyDir/RemittanceHistory/remittanceHistory"),
      meta: "لیست سوابق حواله ها",
    },
    {
      path: "/remittanceDischarge",
      name: "remittanceDischarge",
      component: () => import("../views/CompanyDir/RemittanceDischarge/index"),
      meta: "لیست حواله های تخیلیه",
    },
    {
      path: "/remittanceDischarge/new",
      name: "remittanceDischargeNew",
      component: () => import("../views/CompanyDir/RemittanceDischarge/store"),
      meta: "ایجاد حواله تخیلیه",
    },
    {
      path: "/findRemittanceHistory",
      name: "findRemittanceHistory",
      component: () =>
        import("../views/CompanyDir/RemittanceHistory/findRemittanceHistory"),
      meta: "جستجو در سوابق حواله ها",
    },
    {
      path: "/company/companiesRents",
      name: "company-rentCompanies",
      component: () => import("../views/CompanyDir/Receipts/listRents"),
      meta: "لیست کرایه ها",
    },
  );
}
if (
  (localStorage.getItem("role") === "FACTORY" &&
    localStorage.getItem("token")) ||
  (localStorage.getItem("role") === "FACTORY_MEMBER" &&
    localStorage.getItem("token"))
) {
  routes.push(
    {
      path: "/turnOver",
      name: "turnOver",
      component: () => import("../views/FactoryDir/TurnOver/index"),
      meta: "گردش حساب",
    },
    {
      path: "/bankAccountList",
      component: () => import("../views/SharedPages/bankAccountList.vue"),
      meta: {
        title: "حساب ها",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/address",
      component: () => import("../views/SharedPages/address.vue"),
      meta: {
        title: "آدرس ها",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/banDriver",
      component: () => import("../views/SharedPages/banDriverList.vue"),
      meta: {
        title: "راننده های مسدود",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/withdrawList",
      component: () => import("../views/SharedPages/withdrawList.vue"),
      meta: {
        title: "برداشت",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/paymentRent",
      name: "paymentRent",
      component: () => import("../views/SharedPages/paymentRent.vue"),
      meta: {
        title: "پرداخت کرایه",
        layout: "AppLayoutUser",
      },
    },
    {
      path: "/f/profile",
      component: profileFactory,
      children: [
        {
          path: "",
          name: "profileFactory",
          component: () => import("@/views/FactoryDir/Profile/info.vue"),
          meta: {
            title: "پروفایل",
          },
        },
        {
          path: "edit",
          name: "editProfileFactory",
          component: () => import("@/views/FactoryDir/Profile/edit.vue"),
          meta: {
            title: "ویرایش پروفایل",
          },
        },
      ],
      meta: {
        title: "profile",
        layout: "AppLayoutUser",
        // guest: true
      },
    },
    {
      path: "/tracking/:id",
      name: "FactoryDirRemittanceTracking",
      component: () => import("../views/FactoryDir/Remittance/tracking"),
      meta: "مسیر طی شده",
    },
    {
      path: "/tickets",
      name: "tickets",
      component: tickets,
      meta: {
        title: "tickets",
        layout: "AppLayoutUser",
        guest: true,
      },
    },
    {
      path: "/companiesRents",
      name: "companiesRents",
      component: () => import("../views/FactoryDir/Receipts/listRents"),
      meta: "لیست کرایه ها",
    },
    {
      path: "/exit",
      name: "exit",
      component: () => import("../views/Exit/Exit"),
      meta: "خروج",
    },
    {
      path: "/users",
      name: "users",
      component: () => import("../views/FactoryDir/Users/index"),
      meta: "لیست کاربران واحد صنفی",
    },
    {
      path: "/users/new",
      name: "createUser",
      component: () => import("../views/FactoryDir/Users/new"),
      meta: "ایجاد کاربر واحد صنفی",
    },
    {
      path: "/users/edit/:id",
      name: "editUser",
      component: () => import("../views/FactoryDir/Users/edit"),
      meta: "ویرایش کاربر واحد صنفی",
    },
    {
      path: "/workDays",
      name: "workDays",
      component: () => import("../views/FactoryDir/WorkDays/index"),
      meta: "لیست روز های کاری",
    },
    {
      path: "/remittanceDischarge",
      name: "remittanceDischarge",
      component: () => import("../views/FactoryDir/RemittanceDischarge/index"),
      meta: "لیست حواله های تخیلیه",
    },
    {
      path: "/workDays/store",
      name: "workDayStore",
      component: () => import("../views/FactoryDir/WorkDays/store"),
      meta: "ایجاد روز کاری",
    },
    {
      path: "/payments",
      name: "payments",
      component: () => import("../views/FactoryDir/Receipts/payment"),
      meta: "درخواست های واریز",
    },
    {
      path: "/receipts",
      name: "receipts",
      component: () => import("../views/FactoryDir/Receipts/index"),
      meta: "سوابق ثبت فیش",
    },
    {
      path: "/storeReceipt",
      name: "storeReceipt",
      component: () => import("../views/FactoryDir/Receipts/store"),
      meta: "ثبت فیش جدید",
    },
    {
      path: "/orders",
      name: "orders",
      component: () => import("../views/FactoryDir/Orders/index"),
      meta: "اعلام بار های جاری",
    },
    {
      path: "/parsfoolad/new/order",
      name: "parsfooladNewOrders",
      component: () => import("../views/Orders/Parsfoolad/new"),
      meta: "اعلام بار جدید فولاد",
    },
    ...( localStorage.getItem("customUser") ? [
      {
        path: "/parsfoolad/orders",
        name: "parsfooladOrders",
        component: () => import("../views/Orders/Parsfoolad/index"),
        meta: "اعلام بارهای فولاد",
      },
    ] : []),
    {
      path: "/tracking",
      name: "tracking",
      component: () => import("../views/FactoryDir/Tracking/index"),
      meta: "ردیابی حواله ها",
    },
    {
      path: "/orders/new",
      name: "storeOrder",
      component: () => import("../views/FactoryDir/Orders/new"),
      meta: "اعلام بار جدید",
    },
    {
      path: "/orders/detail/:orderId",
      name: "detailOrder",
      component: () => import("../views/FactoryDir/Orders/Detail/index"),
      meta: "جزییات اعلام بار",
    },
    {
      path: "/orderHistory",
      name: "orderHistory",
      component: () => import("../views/FactoryDir/OrderHistory/orderHistory"),
      meta: "لیست سوابق اعلام بار",
    },
    {
      path: "/remittance",
      name: "remittance",
      component: () => import("../views/FactoryDir/Remittance/index"),
      meta: "لیست حواله های جاری",
    },
    ...(localStorage.getItem("customUser") ? [
      {
        path: "/remittance/parsfoolad",
        name: "remittance-parsfoolad",
        component: () => import("../views/FactoryDir/Remittance/parsfoolad/index"),
        meta: "حواله های فولاد",
      },
      {
        path: "/remittance/parsfoolad/inputs",
        name: "remittance-parsfoolad-inputs",
        component: () => import("../views/FactoryDir/Remittance/parsfoolad/inputs"),
        meta: "ورودی های فولاد",
      },
    ] : []),
    {
      path: "/remittanceHistory",
      name: "remittanceHistory",
      component: () =>
        import("../views/FactoryDir/RemittanceHistory/remittanceHistory"),
      meta: "لیست سوابق حواله ها",
    },
    {
      path: "/hall-announcement/list",
      name: "createUser",
      component: () =>
        import("../views/FactoryDir//hall-announcement/index.vue"),
      meta: "سالن اعلام بار",
    },
    {
      path: "/hall-announcement/list/:type",
      name: "createUser",
      component: () =>
        import("../views/FactoryDir//hall-announcement/index.vue"),
      meta: "سوابق اعلام بار",
    },
    {
      path: "/findRemittanceHistory",
      name: "findRemittanceHistory",
      component: () =>
        import("../views/FactoryDir/RemittanceHistory/findRemittanceHistory"),
      meta: "جستجو در سوابق حواله ها",
    }
  );
}
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // document.getElementById('satrex').scrollIntoView();
  },
});

router.beforeEach((to, from, next) => {
  // let token = localStorage.getItem('token');
  // if (to.name === 'registerFactory' || to.name === 'registerCompany' || to.name === 'login'  && token == null) next(to.name)
  // else next()
  // if (to.name === 'registerCompany' && token == null) next({ name: 'registerCompany' })
  // else next()
  // if (to.name !== 'login'  && token == null) next({name : 'login'})
  // else next()
  document.title = to.meta.title ? to.meta.title : to.meta;
  next();
});
export default router;
